import { Button, Grid, Container, TextareaAutosize, styled } from "@material-ui/core";
import { makeStyles, withStyles } from "@material-ui/core/styles";
import React, { useState, useContext, useEffect } from "react";
import { StoreContext } from "../../store/store";
import { Observer } from "mobx-react-lite";
import { Form, Formik } from "formik";
import Typography from "@material-ui/core/Typography";
import CircularProgress from "@material-ui/core/CircularProgress";
import CommonNavbar from "../../Navbars/CommonNavbar/CommonNavbar";
import TextTranslation from "../../Config/TextTranslation";
import TextField from "@material-ui/core/TextField";
import logo from "../../images/MIE_Dark_Black.png";
import Colors from "../../Config/Colors";
import * as yup from "yup";
import axios from "axios";
import Url from "../../Config/Url";
import facebook from "../../images/facebook.png";
import twitter from '../../images/twitter.png';
import instagram from '../../images/instagram.png';
import whatsapp_white from '../../images/whatsapp.png';

import linkedin from '../../images/linkedin.png';
import tiktok from '../../images/tiktok.png';
import whatsapp from '../../images/whatsapp.png';
import handshake from '../../images/handshake.png';
import youtube from '../../images/youtube.png';
import { useHistory } from "react-router-dom";

const ContactUs = () => {
  const history = useHistory();
  const store = useContext(StoreContext);
  const [load, setLoad] = useState(false); // button loader state

  document.body.style.backgroundColor = Colors.theme_bg_wb[store.theme];
  document.body.style.color = Colors.theme_c_dbw[store.theme];
  // validatoin schema
  let SuggestionSchema = yup.object().shape({
    email: yup
      .string()
      .email(TextTranslation.valid_email_msg[store.langIndex])
      .required(TextTranslation.required_email_msg[store.langIndex]),

    subject: yup
      .string()
      .required(TextTranslation.inp_subject_req_msg[store.langIndex]),

    message: yup
      .string()
      .required(TextTranslation.inp_msg_req_msg[store.langIndex])
      .max(1000, TextTranslation.inp_msg_max_msg[store.langIndex]),
  });

  useEffect(() => {
    const ac = new AbortController();
    return () => ac.abort();
  }, []);

  const CssTextField = withStyles({
    root: {
      '& label.Mui-focused': {
        color: 'red',
      },

      '& .MuiInput-underline:after': {
        borderBottomColor: 'red',
      },
      '& .MuiOutlinedInput-input': {
        borderRadius: "7px",
        backgroundColor: Colors.grey,
        borderColor: Colors.inputBorder,
      },
    },
  })(TextField);

  const WhiteThemeTextareaAutosize = styled(TextareaAutosize)({

    color: "#202124",
    backgroundColor: Colors.grey,
    borderColor: Colors.inputBorder,
    borderRadius: '7px',

  })
  const DarkThemeTextareaAutosize = styled(TextareaAutosize)({

    color: 'white',
    border: '1px solid #303134',
    borderRadius: '3px',
    backgroundColor: '#303134',

  })
  const DarkThemeTextField = styled(TextField)({

    '& .MuiFormLabel-root': {
      color: 'white',

    },
    '& .MuiOutlinedInput-notchedOutline': {
      backgroundColor: '#303134',
    },
    '&.Mui-focused': {
      color: 'red'
    },
    '& .MuiOutlinedInput-root.Mui-error .MuiOutlinedInput-notchedOutline': {
      borderColor: 'red'
    },
    '& .MuiOutlinedInput-notchedOutline': {
      borderColor: '#303134',
      backgroundColor: '#303134'

    },
  });


  const WhiteThemeTextField = styled(TextField)({

    '& .MuiFormLabel-root': {
      color: "#202124"
    },
    '& .MuiOutlinedInput-root.Mui-error .MuiOutlinedInput-notchedOutline': {
      borderColor: 'red'
    }

  });

  return (
    <div className="">
      <CommonNavbar />
      <div className="bg-gradiant row m-0 p-0">
        <div className="col-lg-6 col-md-8 m-md-auto  d-flex ">
          <div className="col-lg-8 col-md-10 col-12 m-auto text-center mt-lg-auto mt-md-4 mt-4" >
            <h2 style={
              store.langIndex == 0
                ? { fontFamily: "Raleway, sans-serif" }
                : store.langIndex == 1
                  ? { fontFamily: "JameelNoori" }
                  : { fontFamily: "Arabic" }
            }>Join Team of Contributors</h2>
            <p style={
              store.langIndex == 0
                ? { fontFamily: "Raleway, sans-serif" }
                : store.langIndex == 1
                  ? { fontFamily: "JameelNoori" }
                  : { fontFamily: "Arabic" }
            }>Join our dynamic team of contributors where diversity, creativity, and excellence are celebrated.</p>

            <Button
              className="mt-2 col-lg-8 col-12 btn p-3 btn-radius"
              type="submit"
              fullWidth
              onClick={() => {
                history.push('/join');
              }}
              variant="contained"
              style={{
                backgroundColor: "#247034",
                color: Colors.white,
              }}
            >
              {load ? (
                <CircularProgress
                  size={30}
                  style={{ color: Colors.white }}
                />
              ) : (
                <span
                  style={
                    store.langIndex == 0
                      ? { fontFamily: "Raleway, sans-serif" }
                      : store.langIndex == 1
                        ? { fontFamily: "jameelNoori", fontSize: 18 }
                        : { fontFamily: "Arabic", fontSize: 18 }
                  }
                >
                  <img style={{ width: '30px' }} src={handshake} className="img-fluid img-responsive mt-0 pt-0 w-5 mx-2" />
                  Join Team of Contributors
                </span>
              )}
            </Button>
            {/* <a target="_blank" className=" text-decoration-none" rel="noreferrer noopener" href='https://wa.link/0cxply'>

              <Button target="_blank"
                className="mt-2 col-8 btn p-3 btn-radius d-flex justify-content-center align-items-center "
                type="submit"
                fullWidth
                variant="contained"
                style={{
                  backgroundColor: '#25D366',
                  color: Colors.white,
                }}
              >
                {load ? (
                  <CircularProgress
                    size={30}
                    style={{ color: Colors.white }}
                  />
                ) : (
                  <span
                    style={
                      store.langIndex == 0
                        ? { fontFamily: "Raleway, sans-serif" }
                        : store.langIndex == 1
                          ? { fontFamily: "jameelNoori", fontSize: 18 }
                          : { fontFamily: "Arabic", fontSize: 18 }
                    }
                  >
                    <img style={{ width: '30px' }} src={whatsapp} className="img-fluid img-responsive mt-0 pt-0 w-5 mx-2" />
                    Support/Feedback
                  </span>
                )}
              </Button>
            </a> */}
            <a target="_blank" style={{ color: '#247034' }} className=" text-decoration-none col-lg-8 col-12" rel="noreferrer noopener" href='https://wa.link/0cxply'>
              <Button target="_blank"
                // className=" btn btn-radius d-flex justify-content-center align-items-center "
                className="Feedback-btn-contactus mt-2 col-8 btn p-3 btn-radius d-flex justify-content-center align-items-center "

                type="submit"
                fullWidth
                variant="contained"
                style={{
                  border: '1px solid #247034',
                  color: '#247034',
                  backgroundColor: 'transparent'
                }}
              >
                {load ? (
                  <CircularProgress
                    size={30}
                    style={{ color: Colors.primary }}
                  />
                ) : (
                  <span
                    style={
                      store.langIndex == 0
                        ? { fontFamily: "Raleway, sans-serif", fontSize: '0.875rem' }
                        : store.langIndex == 1
                          ? { fontFamily: "jameelNoori", fontSize: 10 }
                          : { fontFamily: "Arabic", fontSize: 10 }
                    }
                    className="d-flex justify-content-center align-content-center"
                  >
                    <img style={{ width: '30px', height: '30px' }} src={whatsapp_white} className="img-fluid img-responsive mt-0 pt-0 w-5 mx-2" />
                    <svg className="img-fluid img-responsive mt-0 pt-0 w-5 mx-2" width="30" height="30" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <g clip-path="url(#clip0_4178_11253)">
                        <path fill-rule="evenodd" clip-rule="evenodd" d="M14.8651 13.403C14.4109 13.5886 14.1208 14.2997 13.8264 14.663C13.6754 14.8491 13.4954 14.8781 13.2634 14.7848C11.5586 14.1056 10.2517 12.968 9.31091 11.3991C9.15153 11.1558 9.18013 10.9636 9.37231 10.7377C9.65638 10.403 10.0136 10.0228 10.0904 9.57187C10.2611 8.57437 8.957 5.48016 7.23481 6.88219C2.27919 10.9205 15.5017 21.6309 17.8881 15.8381C18.5631 14.1961 15.6179 13.0945 14.8651 13.403ZM12.0001 21.9037C10.2475 21.9037 8.52294 21.4378 7.01309 20.5556C6.77075 20.4136 6.47778 20.3761 6.20684 20.4497L2.92606 21.3502L4.06888 18.8325C4.2245 18.4898 4.18466 18.0909 3.96481 17.7863C2.74231 16.0917 2.09591 14.0911 2.09591 12C2.09591 6.53859 6.53872 2.09578 12.0001 2.09578C17.4615 2.09578 21.9039 6.53859 21.9039 12C21.9039 17.4609 17.4611 21.9037 12.0001 21.9037ZM12.0001 0C5.38325 0 0.000125453 5.38312 0.000125453 12C0.000125453 14.3278 0.661063 16.5633 1.91684 18.5034L0.0938754 22.5183C-0.0744058 22.8891 -0.0129995 23.3231 0.250438 23.632C0.452938 23.8687 0.745907 24 1.04825 24C1.72419 24 5.40997 22.8417 6.34794 22.5844C8.08184 23.512 10.0267 24 12.0001 24C18.6165 24 24.0001 18.6164 24.0001 12C24.0001 5.38312 18.6165 0 12.0001 0Z" fill="#247034" />
                      </g>
                      <defs>
                        <clipPath id="clip0_4178_11253">
                          <rect width="30" height="30" fill="white" />
                        </clipPath>
                      </defs>
                    </svg>
                    {/* Support/Feedback */}
                    <span style={{ fontFamily: "Raleway, sans-serif", marginTop: '5px' }}>Support/Feedback</span>

                  </span>
                )}
              </Button>
            </a>
            {/* <div style={{ marginLeft: '15px' }} className="my-2">
              <a target="_blank" rel="noreferrer noopener" href='https://wa.link/0cxply'>
                <img style={{ width: '120px' }} src={whatsapp} className="img-fluid img-responsive mt-0 pt-0 w-5" />
              </a>
            </div> */}
          </div>
        </div>
        <div className="col-lg-6 col-md-8 m-md-auto">
          <div className="col-lg-8 col-md-10 col-12 m-auto">
            <Observer >
              {() => (
                <>
                  <Container component="main" className=" align-middle p-0 m-0" style={{
                    color: Colors.theme_c_dbw[store.theme],
                    // backgroundColor: Colors.theme_bg_wb[store.theme]
                  }}>

                    <h1 className="font-weight-bold text-center pt-4"
                      style={
                        store.langIndex == 0
                          ? { fontFamily: "Raleway, sans-serif" }
                          : store.langIndex == 1
                            ? { fontFamily: "JameelNoori" }
                            : { fontFamily: "Arabic" }
                      }
                    >
                      {TextTranslation.suggestion_contact_us[store.langIndex]}
                    </h1>
                    <Typography className="text-center py-3"
                      style={
                        store.langIndex == 0
                          ? { fontFamily: "Raleway, sans-serif" }
                          : store.langIndex == 1
                            ? { fontFamily: "JameelNoori" }
                            : { fontFamily: "Arabic" }
                      }>
                      {TextTranslation.contact_us_text[store.langIndex]}

                    </Typography>
                    <Formik
                      fullWidth

                      //initialize values

                      initialValues={{
                        email: "",
                        subject: "",
                        message: "",
                      }}
                      validationSchema={SuggestionSchema}
                      onSubmit={(values) => {

                        // FormData append

                        var suggestionbodyformData = new FormData();
                        suggestionbodyformData.append("email", values.email);
                        suggestionbodyformData.append("subject", values.subject);
                        suggestionbodyformData.append("message", values.message);

                        setLoad(true);

                        axios({
                          method: "post",
                          url: `${Url.link}/mail.php?`,
                          data: suggestionbodyformData,
                          headers: {
                            "Content-Type": "multipart/form-data",
                          },
                        })
                          .then((res) => {
                            console.log(res.data);
                            // message deliverd alert
                            alert(TextTranslation.delivered[store.langIndex]);
                            setLoad(false);
                          })
                          .catch((err) => {
                            console.log(err);
                          });
                      }}
                    >

                      {({ errors, handleChange, touched, handleBlur, isValid }) => (
                        <Form className="pt-2 text-center">
                          {store.langIndex == 0 ? (
                            // store.theme==0 ? {} :  {}
                            store.theme == 0 ? (
                              <CssTextField
                                fullWidth
                                onChange={handleChange}
                                onBlur={handleBlur}
                                variant="outlined"
                                className="mb-3"
                                label={TextTranslation.inp_plac_email[store.langIndex]}
                                name="email"
                                error={errors.email && touched.email}
                                helperText={
                                  errors.email && touched.email ? errors.email : null
                                }
                                style={{ color: Colors.white, }}

                              />) : (<DarkThemeTextField
                                fullWidth
                                onChange={handleChange}
                                onBlur={handleBlur}
                                variant="outlined"
                                className="mb-3"
                                label={TextTranslation.inp_plac_email[store.langIndex]}
                                name="email"
                                error={errors.email && touched.email}
                                helperText={
                                  errors.email && touched.email ? errors.email : null
                                }
                                style={{ color: Colors.white, }}

                              />)
                          ) : (
                            store.theme == 0 ? (
                              <CssTextField

                                fullWidth
                                onChange={handleChange}
                                onBlur={handleBlur}
                                inputProps={
                                  store.langIndex == 1
                                    ? {
                                      min: 0,
                                      style: {
                                        textAlign: "right",
                                        color: Colors.primary,
                                        fontFamily: "JameelNoori",
                                        fontSize: 18,

                                      },
                                    }
                                    : {
                                      min: 0,
                                      style: {
                                        textAlign: "right",
                                        color: Colors.primary,
                                        fontFamily: "Arabic",
                                        fontSize: 18,
                                      },
                                    }
                                }
                                FormHelperTextProps={
                                  store.langIndex == 1
                                    ? {
                                      style: {
                                        textAlign: "right",
                                        fontFamily: "JameelNoori",
                                        fontSize: 16,
                                      },
                                    }
                                    : {
                                      style: {
                                        textAlign: "right",
                                        fontFamily: "Arabic",
                                      },
                                    }
                                }
                                variant="outlined"
                                className="mb-3"
                                placeholder={
                                  TextTranslation.inp_plac_email[store.langIndex]
                                }
                                name="email"
                                error={errors.email && touched.email}
                                helperText={
                                  errors.email && touched.email ? errors.email : null
                                }
                              />) : (
                              <DarkThemeTextField

                                fullWidth
                                onChange={handleChange}
                                onBlur={handleBlur}
                                inputProps={
                                  store.langIndex == 1
                                    ? {
                                      min: 0,
                                      style: {
                                        textAlign: "right",
                                        color: Colors.primary,
                                        fontFamily: "JameelNoori",
                                        fontSize: 18,
                                      },
                                    }
                                    : {
                                      min: 0,
                                      style: {
                                        textAlign: "right",
                                        color: Colors.primary,
                                        fontFamily: "Arabic",
                                        fontSize: 18,
                                      },
                                    }
                                }
                                FormHelperTextProps={
                                  store.langIndex == 1
                                    ? {
                                      style: {
                                        textAlign: "right",
                                        fontFamily: "JameelNoori",
                                        fontSize: 16,
                                      },
                                    }
                                    : {
                                      style: {
                                        textAlign: "right",
                                        fontFamily: "Arabic",
                                      },
                                    }
                                }
                                variant="outlined"
                                className="mb-3"
                                placeholder={
                                  TextTranslation.inp_plac_email[store.langIndex]
                                }
                                name="email"
                                error={errors.email && touched.email}
                                helperText={
                                  errors.email && touched.email ? errors.email : null
                                }
                              />
                            )
                          )}
                          {store.langIndex == 0 ? (
                            store.theme == 0 ? (
                              <CssTextField
                                fullWidth
                                onChange={handleChange}
                                onBlur={handleBlur}
                                variant="outlined"
                                name="subject"
                                label={TextTranslation.subject[store.langIndex]}
                                className="mb-3"
                                error={errors.subject && touched.subject}
                                helperText={
                                  errors.subject && touched.subject
                                    ? errors.subject
                                    : null
                                }
                              />) : (
                              <DarkThemeTextField
                                fullWidth
                                onChange={handleChange}
                                onBlur={handleBlur}
                                variant="outlined"
                                name="subject"
                                label={TextTranslation.subject[store.langIndex]}
                                className="mb-3"
                                error={errors.subject && touched.subject}
                                helperText={
                                  errors.subject && touched.subject
                                    ? errors.subject
                                    : null
                                }
                              />
                            )
                          ) : (
                            store.theme == 0 ? (
                              <CssTextField
                                fullWidth
                                onChange={handleChange}
                                onBlur={handleBlur}
                                inputProps={
                                  store.langIndex == 1
                                    ? {
                                      min: 0,
                                      style: {
                                        textAlign: "right",
                                        color: Colors.primary,
                                        fontFamily: "JameelNoori",
                                        fontSize: 18,

                                      },
                                    }
                                    : {
                                      min: 0,
                                      style: {
                                        textAlign: "right",
                                        color: Colors.primary,
                                        fontFamily: "Arabic",
                                        fontSize: 18,

                                      },
                                    }
                                }
                                FormHelperTextProps={
                                  store.langIndex == 1
                                    ? {
                                      style: {
                                        textAlign: "right",
                                        fontFamily: "JameelNoori",
                                        fontSize: 16,
                                      },
                                    }
                                    : {
                                      style: {
                                        textAlign: "right",
                                        fontFamily: "Arabic",
                                        fontSize: 16,
                                      },
                                    }
                                }
                                variant="outlined"
                                name="subject"
                                placeholder={TextTranslation.subject[store.langIndex]}
                                className="mb-2"
                                error={errors.subject && touched.subject}
                                helperText={
                                  errors.subject && touched.subject
                                    ? errors.subject
                                    : null
                                }
                              />) : (
                              <DarkThemeTextField
                                fullWidth
                                onChange={handleChange}
                                onBlur={handleBlur}
                                inputProps={
                                  store.langIndex == 1
                                    ? {
                                      min: 0,
                                      style: {
                                        textAlign: "right",
                                        color: Colors.primary,
                                        fontFamily: "JameelNoori",
                                        fontSize: 18,
                                      },
                                    }
                                    : {
                                      min: 0,
                                      style: {
                                        textAlign: "right",
                                        color: Colors.primary,
                                        fontFamily: "Arabic",
                                        fontSize: 18,
                                      },
                                    }
                                }
                                FormHelperTextProps={
                                  store.langIndex == 1
                                    ? {
                                      style: {
                                        textAlign: "right",
                                        fontFamily: "JameelNoori",
                                        fontSize: 16,
                                      },
                                    }
                                    : {
                                      style: {
                                        textAlign: "right",
                                        fontFamily: "Arabic",
                                        fontSize: 16,
                                      },
                                    }
                                }
                                variant="outlined"
                                name="subject"
                                placeholder={TextTranslation.subject[store.langIndex]}
                                className="mb-3"
                                error={errors.subject && touched.subject}
                                helperText={
                                  errors.subject && touched.subject
                                    ? errors.subject
                                    : null
                                }
                              />
                            )
                          )}
                          {store.langIndex == 0 ? (
                            store.theme == 0 ? (
                              <WhiteThemeTextareaAutosize
                                onChange={handleChange}
                                onBlur={handleBlur}
                                variant="outlined"
                                name="message"
                                placeholder={
                                  TextTranslation.inp_plac_message[store.langIndex]
                                }
                                rowsMin={4}
                                style={{ width: "100%" }}
                                className="mb-2 p-3"
                                error={errors.message && touched.message}
                              />) : (<DarkThemeTextareaAutosize
                                onChange={handleChange}
                                onBlur={handleBlur}
                                variant="outlined"
                                name="message"
                                placeholder={
                                  TextTranslation.inp_plac_message[store.langIndex]
                                }
                                rowsMin={4}
                                style={{ width: "100%" }}
                                className="mb-2"
                                error={errors.message && touched.message}
                              />)
                          ) : (
                            store.theme == 0 ? (
                              <WhiteThemeTextareaAutosize
                                fullWidth
                                onChange={handleChange}
                                onBlur={handleBlur}
                                variant="outlined"
                                name="message"
                                rowsMin={4}
                                style={
                                  store.langIndex == 1
                                    ? {
                                      width: "100%",
                                      textAlign: "right",
                                      fontFamily: "jameelNoori",
                                      fontSize: 18,
                                      color: Colors.primary,
                                      backgroundColor: Colors.theme_bg_wg[store.theme]
                                    }
                                    : {
                                      width: "100%",
                                      textAlign: "right",
                                      fontFamily: "Arabic",
                                      fontSize: 18,
                                      color: Colors.primary,
                                    }
                                }
                                placeholder={
                                  TextTranslation.inp_plac_message[store.langIndex]
                                }
                                className="mb-2"
                                error={errors.message && touched.message}
                              />) : (<DarkThemeTextareaAutosize
                                fullWidth
                                onChange={handleChange}
                                onBlur={handleBlur}
                                variant="outlined"
                                name="message"
                                rowsMin={4}
                                style={
                                  store.langIndex == 1
                                    ? {
                                      width: "100%",
                                      textAlign: "right",
                                      fontFamily: "jameelNoori",
                                      fontSize: 18,
                                      color: Colors.primary,
                                    }
                                    : {
                                      width: "100%",
                                      textAlign: "right",
                                      fontFamily: "Arabic",
                                      fontSize: 18,
                                      color: Colors.primary,
                                    }
                                }
                                placeholder={
                                  TextTranslation.inp_plac_message[store.langIndex]
                                }
                                className="mb-2"
                                error={errors.message && touched.message}
                              />)
                          )}
                          <Button
                            className="mt-2 col-8 btn p-3 btn-radius"
                            type="submit"
                            fullWidth
                            variant="contained"
                            style={{
                              backgroundColor: Colors.primary,
                              color: Colors.white,
                            }}
                            disabled={!isValid}
                          >
                            {load ? (
                              <CircularProgress
                                size={30}
                                style={{ color: Colors.white }}
                              />
                            ) : (
                              <span
                                style={
                                  store.langIndex == 0
                                    ? { fontFamily: "Raleway, sans-serif" }
                                    : store.langIndex == 1
                                      ? { fontFamily: "jameelNoori", fontSize: 18 }
                                      : { fontFamily: "Arabic", fontSize: 18 }
                                }
                              >
                                {TextTranslation.sub[store.langIndex]}
                              </span>
                            )}
                          </Button>
                        </Form>
                      )}
                    </Formik>
                    <div className="text-center col-lg-12 col-md-12 col-12 my-3" >
                      <div className="col-12 d-flex align-items-center  justify-content-center m-auto m-lg-0   ">
                        <div style={{ marginLeft: '15px' }}>
                          <a target="_blank" rel="noreferrer noopener" href='https://www.instagram.com/minhaj.app/'>
                            <img style={{ width: '30px' }} src={instagram} className="img-fluid img-responsive mt-0 pt-0 w-5" />
                          </a>
                        </div>
                        <div style={{ marginLeft: '15px' }}>
                          <a target="_blank" rel="noreferrer noopener" href='https://fb.com/MinhajApp'>
                            <img style={{ width: '30px' }} src={facebook} className="img-fluid img-responsive mt-0 pt-0 w-5" />
                          </a>
                        </div>
                        <div style={{ marginLeft: '15px' }}>
                          <a target="_blank" rel="noreferrer noopener" href='https://twitter.com/MinhajApp'>
                            <img style={{ width: '30px' }} src={twitter} className="img-fluid img-responsive mt-0 pt-0 w-5" />
                          </a>
                        </div>
                        <div style={{ marginLeft: '15px' }}>
                          <a target="_blank" rel="noreferrer noopener" href='https://www.youtube.com/@MinhajApp'>
                            <img style={{ width: '30px' }} src={youtube} className="img-fluid img-responsive mt-0 pt-0 w-5" />
                          </a>
                        </div>
                        <div style={{ marginLeft: '15px' }}>
                          <a target="_blank" rel="noreferrer noopener" href='https://www.linkedin.com/company/MinhajApp'>
                            <img style={{ width: '30px' }} src={linkedin} className="img-fluid img-responsive mt-0 pt-0 w-5" />
                          </a>
                        </div>
                        <div style={{ marginLeft: '15px' }}>
                          <a target="_blank" rel="noreferrer noopener" href=' https://www.tiktok.com/@minhajapp'>
                            <img style={{ width: '30px' }} src={tiktok} className="img-fluid img-responsive mt-0 pt-0 w-5" />
                          </a>
                        </div>


                      </div>
                    </div>
                  </Container>
                </>
              )}
            </Observer>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ContactUs;
